import React from 'react';
import { motion } from 'framer-motion';
import { highlightTerms } from '../highlightTerms';
import { ArrowRight, Zap } from 'lucide-react';

export const PhasesSlide = ({ slide }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.3, delayChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
  };

  return (
    <div
      className="h-full w-full flex flex-col justify-center items-center px-8 md:px-12 lg:px-20 py-12"
      data-testid={`slide-${slide.id}`}
    >
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="max-w-5xl w-full"
      >
        <motion.h2
          variants={itemVariants}
          className="pres-font-heading text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white mb-16 text-center"
        >
          {highlightTerms(slide.title)}
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {slide.phases?.map((phase, idx) => (
            <motion.div
              key={idx}
              variants={itemVariants}
              className="group"
            >
              <div className="relative bg-[#2A1D45]/60 backdrop-blur-md border border-white/10 rounded-2xl p-10 hover:border-[#D31113]/50 transition-all duration-300 h-full">
                {/* Phase Icon */}
                <div className="absolute -top-6 left-8">
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${idx === 0 ? 'bg-[#D31113]' : 'bg-white'}`}>
                    {phase.icon === 'push' ? (
                      <ArrowRight className={`w-6 h-6 ${idx === 0 ? 'text-white' : 'text-[#17072F]'}`} />
                    ) : (
                      <Zap className={`w-6 h-6 ${idx === 0 ? 'text-white' : 'text-[#17072F]'}`} />
                    )}
                  </div>
                </div>

                <div className="mt-4">
                  <h3 className="pres-font-heading text-3xl md:text-4xl font-bold text-[#D31113] uppercase mb-4">
                    {phase.name}
                  </h3>
                  <p className="font-sans text-xl text-gray-200">
                    {highlightTerms(phase.desc)}
                  </p>
                </div>

                {/* Visual indicator */}
                <div className="mt-8 flex items-center gap-2">
                  {idx === 0 ? (
                    <>
                      <div className="h-2 flex-1 bg-[#D31113] rounded-full" />
                      <div className="h-2 w-8 bg-[#D31113]/40 rounded-full" />
                      <div className="h-2 w-4 bg-[#D31113]/20 rounded-full" />
                    </>
                  ) : (
                    <>
                      <div className="h-2 w-4 bg-white/20 rounded-full" />
                      <div className="h-2 w-8 bg-white/40 rounded-full" />
                      <div className="h-2 flex-1 bg-white rounded-full" />
                    </>
                  )}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};
